export enum AuthComponent {
  Login,
  ForgotPassword,
  ResetPassword,
  ActivateAccount,
  AcceptInvitation,
  Register,
  Landing,
  TwoFactorChallenge = "2fa_challenge",
}
